export default __webpack_public_path__ + "static/24-73e5e3f0a55911163a37b217be258fdd.jpg";